import { Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { ReportBaseService } from './report-base.service';

import { UtilsService } from './utils.service';
import { SalesOrders_DatasourceService } from './SalesOrders.datasource.index';

interface ISalesOrders_outbound_bill_of_lading_reportServiceInParams {
  orderId: number, shipmentId?: number}

interface ISalesOrders_outbound_bill_of_lading_reportServiceData {
  Header?: { result?: { Id?: number, CreatedSysUser?: string, LookupCode?: string, OwnerReference?: string, RequestedDeliveryDate?: string, VendorReference?: string, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { BillOfLading?: string, GrossWeight?: number, ItemCount?: number, PalletCount?: number, SealId?: string, ShippedDate?: string, TrackingIdentifier?: string, TrailerId?: string } }[], PreferredCarrier?: { Name?: string }, PreferredWarehouse?: { Name?: string, WarehousesContactsLookup?: { ContactId?: number, Contact?: { PrimaryTelephone?: string, Address?: { AttentionOf?: string, City?: string, Country?: string, Line1?: string, PostalCode?: string, State?: string } } }[] }, Project?: { Name?: string, ProjectsContactsLookup?: { ContactId?: number, Contact?: { Id?: number, Address?: { City?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[] }, ShipToAddress?: { AttentionOf?: string, FirstName?: string, LastName?: string, Line1?: string, Line2?: string, City?: string, State?: string, PostalCode?: string, Country?: string, PrimaryTelephone?: string, OrderId?: number } }[] }
  Details?: { result?: { Contents?: { ShipmentId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, Amount?: number, PackagedAmount?: number, LotLookupCode?: string, MaterialLookupCode?: string, MaterialDescription?: string, NetWeight?: number, GrossWeight?: number, WeightUomId?: number, OrderId?: number, LicensePlateLookupCode?: string, WeightUom?: string, Uom?: string, SerialCount?: number, IsFixedWeight?: boolean }[] } }
  Signature?: { result?: { Id?: number, FileName?: string, FileExtension?: string, Description?: string, CreatedSysDateTime?: string, ModifiedSysDateTime?: string, FileSize?: number, FileContent?: string } }
}

@Injectable({ providedIn: 'root' })
export class SalesOrders_outbound_bill_of_lading_reportService extends ReportBaseService<ISalesOrders_outbound_bill_of_lading_reportServiceInParams, ISalesOrders_outbound_bill_of_lading_reportServiceData> {

  protected reportReferenceName = 'outbound_bill_of_lading_report';
  protected appReferenceName = 'SalesOrders';

  constructor(
    $utils: UtilsService,
    private $datasources: SalesOrders_DatasourceService,
    ) {
      super($utils);
  }

  override throwIfMissingRequiredInParams (inParams: ISalesOrders_outbound_bill_of_lading_reportServiceInParams) {
  }

  protected async getData(inParams: ISalesOrders_outbound_bill_of_lading_reportServiceInParams): Promise<ISalesOrders_outbound_bill_of_lading_reportServiceData> 
  {
    const $utils = this.$utils;
    const $report: { inParams: ISalesOrders_outbound_bill_of_lading_reportServiceInParams } = {
      inParams: inParams
    };

    const data: ISalesOrders_outbound_bill_of_lading_reportServiceData = {
    };
    const datasourcesQueries: (() => Promise<void>)[] = [];

    datasourcesQueries.push(async () => {
      const dsParams = {
        orderId:  $report.inParams.orderId ,
        shipmentId:  $report.inParams.shipmentId 
      };
      
      const dsData = await this.$datasources.SalesOrders.ds_outbound_header_bill_of_lading_report.get(dsParams);
      
      data.Header = dsData;
    });
    datasourcesQueries.push(async () => {
      const dsParams = {
        orderId:  $report.inParams.orderId ,
        shipmentId:  $report.inParams.shipmentId 
      };
      
      const dsData = await this.$datasources.SalesOrders.ds_outbound_details_bill_of_lading_report_advanced.get(dsParams);
      
      data.Details = dsData;
    });
    datasourcesQueries.push(async () => {
      const dsParams = {
        orderId:  $report.inParams.orderId 
      };
      
      const dsData = await this.$datasources.SalesOrders.ds_get_order_signature_attachment.get(dsParams);
      
      data.Signature = dsData;
    });

    await Promise.all(datasourcesQueries.map(t => t()));

    return data;
  }
}
